module.exports = {
      id: "404-robot-usage",
      viewBox: "0 0 280 313",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#404-robot",
      toString: function () {
        return this.url;
      }
    }